import "./Css/App.css";
import { useState, useEffect } from "react";
import Intro from "./Intro";
import Journey from "./Journey";
import Recordings from "./Recordings";
import Footer from "./Footer";
function App() {
  return (
    <div className="App">
      <Intro />
      <Journey />
      <Recordings />
      {/*<Footer />*/}
    </div>
  );
}

export default App;
